<template>
	<div class="page-dashboard relative">
		<div class="container-fluid">
			<div class="d-flex justify-content-between">
				<div><h2 class="text-primary mb-4">{{ $t('Users') }}</h2></div>
				<div class="mb-4 mt-2"><user-statistics></user-statistics></div>
			</div>
			<!-- Table Menu -->
			<div class="table-menu flex-center">
				<div>
					<button
						class="btn btn-submit btn-default text-white mr-4"
						@click="addItem">
						{{ $t('Add User') }}
					</button>
				</div>
				<!-- export -->
				<div>
					<label class="btn btn-primary ml-a mr-2 mb-0 mw-fc">
						<div>
							<div @click="isExportUserVisible = true">{{ $t('Export User') }}</div>
						</div>
					</label>
				</div>
				<!-- import -->
				<div>
					<label class="btn btn-default ml-a mr-2 mb-0 mw-fc">
						<div class="">
							<div @click="isImportUserVisible = true">{{ $t('Import User') }}</div>
						</div>
					</label>
				</div>
				<!-- is roles -->
				<div class="verified-icon-left text-center ml-a"><i class="material-icons text-white absolute pt-1">person</i></div>
				<div class="mr-3">
					<md-menu md-align-trigger :md-offset-x="-30">
						<button class="btn btn-filter-role p-0 m-0" md-menu-trigger>
								<span class="capitalize" v-if="roleFilter === ''">{{$t('All')}}</span>
								<span class="capitalize" v-if="roleFilter === 'super_admin'">{{$t('Admin')}}</span>
								<span class="capitalize pr-3 pl-3" v-if="roleFilter === 'collaborator'">{{$t('Collaborator')}}</span>
								<span class="capitalize" v-if="roleFilter === 'client'">{{$t('Client')}}</span>
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="roleFilter = ''"><span class="text-center minw-87">{{$t('All')}}</span></md-menu-item>
							<md-menu-item @click="roleFilter = 'super_admin'"><span class="text-center minw-87">{{$t('Admin')}}</span></md-menu-item>
							<md-menu-item @click="roleFilter = 'collaborator'"><span class="text-center minw-87">{{$t('Collaborator')}}</span></md-menu-item>
							<md-menu-item @click="roleFilter = 'client'"><span class="text-center minw-87">{{$t('Client')}}</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<!-- is verified -->
				<div class="verified-icon-left text-center"><i class="material-icons text-white absolute pt-1">check</i></div>
				<div class="mr-3">
					<md-menu md-align-trigger :md-offset-x="-30">
						<button class="btn btn-filter-verified p-0 m-0" md-menu-trigger>
								<span class="capitalize" v-if="isVerified === ''">{{$t('All')}}</span>
								<span class="capitalize" v-if="isVerified === '1'">{{$t('Verified')}}</span>
								<span class="capitalize" v-if="isVerified === '0'">{{$t('Unverified')}}</span>
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="isVerified = ''"><span class="text-center minw-70">{{$t('All')}}</span></md-menu-item>
							<md-menu-item @click="isVerified = '1'"><span class="text-center minw-70">{{$t('Verified')}}</span></md-menu-item>
							<md-menu-item @click="isVerified = '0'"><span class="text-center minw-70">{{$t('Unverified')}}</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<!-- is last Login -->
				<div class="verified-icon-left text-center"><i class="material-icons text-white absolute pt-1">sort</i></div>
				<div class="mr-3">
					<md-menu md-align-trigger :md-offset-x="-30">
						<button class="btn btn-filter-last-login p-0 m-0" md-menu-trigger>
								<span class="capitalize" v-if="orderBy === 'id'">{{$t('All')}}</span>
								<span class="capitalize" v-if="orderBy === 'logged_in_at'">{{$t('Last Login')}}</span>
								<span class="capitalize" v-if="orderBy === 'subscription'">{{$t('Subscription')}}</span>
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="lastLoginAt('all')"><span class="text-center minw-85">{{$t('All')}}</span></md-menu-item>
							<md-menu-item @click="lastLoginAt('last')"><span class="text-center minw-85">{{$t('Last Login')}}</span></md-menu-item>
							<md-menu-item @click="lastLoginAt('subscription')"><span class="text-center minw-85">{{$t('Subscription')}}</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<!-- sort -->
				<div class="verified-icon-left text-center"><i class="material-icons text-white absolute pt-1 text-lg pt-2">filter_list</i></div>
				<div class="mr-3">
					<md-menu md-align-trigger :md-offset-x="-20">
						<button class="btn btn-filter-last-transaction p-0 m-0" md-menu-trigger>
								<span class="tf-none" v-if="sortBy === 'desc'">{{$t('Newest on top')}}</span>
								<span class="tf-none" v-if="sortBy === 'asc'">{{$t('Newest on last')}}</span>
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="sortFilter('desc')"><span class="text-center minw-115">{{$t('Newest on top')}}</span></md-menu-item>
							<md-menu-item @click="sortFilter('asc')"><span class="text-center minw-115">{{$t('Newest on last')}}</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<!-- counting -->
				<div class="mr-3">
					<md-menu md-align-trigger md :md-offset-x=10>
						<button class="btn-icon btn p-0 m-0 w-100 btn-click" md-menu-trigger>
								{{ page * limit - (limit - 1) }} - {{ items.length > 0 ? page * limit : items.length }} of {{ totalItems }}
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="changeLimit(10)"><span class="text-center minw-50">10</span></md-menu-item>
							<md-menu-item @click="changeLimit(25)"><span class="text-center minw-50">25</span></md-menu-item>
							<md-menu-item @click="changeLimit(50)"><span class="text-center minw-50">50</span></md-menu-item>
							<md-menu-item @click="changeLimit(100)"><span class="text-center minw-50">100</span></md-menu-item>
							<md-menu-item @click="changeLimit(200)"><span class="text-center minw-50">200</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<div>
					<input
						type="text"
						class="form-control"
						:placeholder="$t('Search')"
						@input="onKeywordChange"
						v-model="keyword"
					/>
				</div>
			</div>
			<!-- Main Table -->
			<table class="table table-striped mb-4">
				<thead>
					<tr>
						<th>{{ $t('No') }}</th>
						<th>{{ $t('Name') }}</th>
						<th>{{ $t('Email') }}</th>
						<th>{{ $t('Role') }}</th>
						<th class="text-center">{{ $t('Subscription') }}</th>
						<th class="text-center">{{ $t('Verified') }}</th>
						<th class="text-center">{{ $t('Last Login') }}</th>
						<th width="25%">{{ $t('') }}</th>
					</tr>
				</thead>
				<div class="p-5 text-center absolute" v-if="isFetching">
					<div class="is-loading large"></div>
				</div>
				<tbody>
					<tr
						v-for="(item,index) in items"
						:key="item.id">
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ numberingList(index) }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.name }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">
							<div>{{ item.email }}</div>
							<div class="text-small text-grey-info">{{ $t('Joined') }}: {{ getRelativeTime(item) }}</div>
						</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">
							<span v-for="(itemRole, index) in item.roles" :key="index">
								<md-chip class="mr-2 chip-item" :class="{'chip-item-hover': hover && hoverItem === item.id}"
									v-if="item.roles[index] !== 'collaborator'"
								>
									{{ formatText(item && item.roles[index] ? item.roles[index] : '') }}
								</md-chip>
								<md-chip class="mr-2 chip-item" :class="{'chip-item-hover': hover && hoverItem === item.id}"
									v-if="item.roles[index] === 'collaborator'"
									v-tooltip.bottom-end="{ content: collaboratorList(item) }"
								>
									{{ formatText(item && item.roles[index] ? item.roles[index] : '') }}
								</md-chip>
							</span>
						</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)" class="text-center">{{ item && item.subscription ? item.subscription : '-' }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)" class="text-center"><i class="material-icons" v-if="item.is_verified">done</i></td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)" class="text-center">{{ getLastLogin(item) }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)" v-if="!showDropDownMenu">
							<button
								v-if="hover && hoverItem === item.id"
								class="btn btn-default btn-icon mr-3"
								v-tooltip="$t('Edit')"
								@click="editItem(item)">
								<i class="material-icons md-18">edit</i>
							</button>
							<button
								v-if="hover && hoverItem === item.id"
								class="btn btn-default btn-icon mr-3"
								v-tooltip="$t('Statistics')"
								@click="getStatistics(item)">
								<i class="material-icons md-18">bar_chart</i>
							</button>
							<button
								v-if="hover && hoverItem === item.id && !item.is_verified"
								class="btn btn-default btn-icon mr-3"
								v-tooltip="$t('Verified')"
								@click="verifiedItem(item)">
								<i class="material-icons md-18">done</i>
							</button>
							<button
								v-if="hover && hoverItem === item.id"
								class="btn btn-default btn-icon mr-3"
								v-tooltip="$t('Limit subscription')"
								@click="limitSubscription(item)">
								<i class="material-icons md-18">storage</i>
							</button>
							<button
								v-if="hover && hoverItem === item.id"
								class="btn btn-default btn-icon mr-3"
								v-tooltip="$t('Settings')"
								@click="settingItem(item)">
								<i class="material-icons md-18">settings</i>
							</button>
							<button
								v-if="hover && hoverItem === item.id"
								class="btn btn-default btn-icon mr-3"
								v-tooltip="$t('Change Password')"
								@click="changePassword(item)">
								<i class="material-icons md-18">lock</i>
							</button>
							<button
								v-if="hover && hoverItem === item.id"
								class="btn btn-danger btn-icon"
								@click="confirmRemoveItem(item)">
								<i class="material-icons md-18">delete</i>
							</button>
						</td>
						<td class="text-right" v-if="showDropDownMenu">
							<md-menu md-size="medium" md-align-trigger>
								<div class="btn btn-icon" md-menu-trigger><i class="material-icons text-white">more_vert</i></div>
								<md-menu-content>
								<md-menu-item @click="editItem(item)">{{$t('Edit')}}</md-menu-item>
								<md-menu-item @click="getStatistics(item)">{{$t('Statistics')}}</md-menu-item>
								<md-menu-item @click="limitSubscription(item)">{{$t('Limit subscription')}}</md-menu-item>
								<md-menu-item @click="settingItem(item)">{{$t('Settings')}}</md-menu-item>
								<md-menu-item @click="changePassword(item)">{{$t('Change Password')}}</md-menu-item>
								<md-menu-item @click="confirmRemoveItem(item)">{{$t('Delete')}}</md-menu-item>
								<md-menu-item @click="verifiedItem(item)" v-if="!item.is_verified">{{$t('Verified')}}</md-menu-item>
								</md-menu-content>
							</md-menu>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="text-center absolute disabled mt-4" v-if="items.length === 0 && !isFetching">{{$t('No User available')}}</div>
			<!-- Table Pagination -->
			<pagination
				v-if="!isFetching"
				:total-pages="totalPages"
				:current-page="page"
				:last-page="lastPage"
				@select="onPageSelected">
			</pagination>
		</div>

		<!-- Modals -->
		<div class="modals">
			<!-- User Form -->
			<user-form
				:data="selected"
				@saved="insertItem"
				@close="isFormVisible = false"
				v-if="isFormVisible"
			/>
			<!-- User Form setiings-->
			<user-form-settings
				:data="selected"
				@saved="insertItem"
				@close="isFormSettingVisible = false"
				v-if="isFormSettingVisible"
			/>
			<!-- User change password-->
			<user-form-force-change-password
				:data="selected"
				@close="isFormChangePasswordVisible = false"
				v-if="isFormChangePasswordVisible"
			/>
			<!-- Modal Package Features Users -->
			<modal-package-features-users
				:data="selected"
				@close="isFormLimitSubsVisible = false"
				v-if="isFormLimitSubsVisible"
			/>
			<!-- Delete Confirmation -->
			<modal
				size="small"
				@close="isConfirmRemoveVisible = false"
				v-if="isConfirmRemoveVisible && selected">
				<template slot="header">
					{{ $t('Remove User') }}
				</template>
				<template slot="body">
					{{ $t('Are you sure want to delete') }} {{ showModalName(selected.name) }}?
				</template>
				<template slot="footer">
					<!-- Is Verified -->
					<label class="custom-control custom-checkbox mb-3">
						<input type="checkbox" class="custom-control-input" v-model="isForceDelete">
						<span class="custom-control-label pt-1">{{ $t('Force Delete') }}</span><span class="text-grey"> (all data related will be deleted)</span>
					</label>
					<div class="w-100 flex-center">
						<button
							class="btn btn-primary"
							:class="{ 'is-loading': isRemoving }"
							@click="removeItem(selected)">
							{{ $t('Remove') }}
						</button>
						<button
							class="btn btn-default"
							@click="isConfirmRemoveVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
			<!-- User change password-->
			<user-form-force-change-password
				:data="selected"
				@close="isFormChangePasswordVisible = false"
				v-if="isFormChangePasswordVisible"
			/>
			<!-- import data -->
			<modal
				size="small-tall"
				@close="isImportUserVisible = false"
				v-if="isImportUserVisible">
				<template slot="header">
					{{ $t('Import User') }}
				</template>
				<template slot="body">
				<div class="modal-import-box">
					<div>
						<div>
							<vue-xlsx :isShowFileXlsx="isImportUserVisible" @on-select-file="handleImportBulk" @drop.prevent="handleImportBulk">
									{{ $t('Select File') }}
							</vue-xlsx>
						</div>
					</div>
				</div>
				<div class="mt-4">
				{{ $t('Download Template For Import') }}:
				</div>
				<div>
					<a href="./../../template-xlsx/Template_Users_Hover.xlsx" download>{{ $t('Download') }} Excel Template - {{ $t('Users') }}</a>
				</div>
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							@click="acceptImport"
							:disabled="!tmpUsers"
							type="submit"
							class="btn btn-submit btn-primary"
							:class="{ 'is-loading': isImporting }">
							<span>{{ $t('Upload') }}</span>
						</button>
						<button
							@click="isImportUserVisible = false"
							type="submit"
							class="btn btn-submit btn-default">
							<span>{{ $t('Cancel') }}</span>
						</button>
					</div>
				</template>
			</modal>
			<div class="text-center">
				<loading :active.sync="isExporting" :is-full-page="fullPage" :background-color="colorOverlay" :color="colorLoading">
					<template slot="after">
						<div class="absolute text-center">{{ $t('Exporting') }}...</div>
					</template>
				</loading>
			</div>
			<!-- export data -->
			<modal
				size="small-tall"
				@close="isExportUserVisible = false"
				v-if="isExportUserVisible"
				:hide-footer="true">
				<template slot="header">
					{{ $t('Export User') }}
				</template>
				<template slot="body">
				<div class="pb-3">
					<p class="text-base text-white mb-3">
						{{ $t('Please select file format for data export') }}:
					</p>
					<div class="p-2">
						<div
							class="pointer"
							:class="{ 'is-loading': isExporting }"
							@click="exportUsers('excel')">
							<img src="/img/xls.png" alt="xls" width="20px;"/>
							<span class="ml-2 text-base item-text-export text-white">{{ $t('Excel File') }}</span>
						</div>
					</div>
					<div class="p-2">
						<div
							class="pointer"
							:class="{ 'is-loading': isExporting }"
							@click="exportUsers('docx')">
							<img src="/img/doc.png" alt="xls" width="20px;"/>
							<span class="ml-2 text-base item-text-export text-white">{{ $t('Document File') }}</span>
						</div>
					</div>
				</div>
				</template>
			</modal>
			<!-- Statistics data -->
			<modal
				size="medium"
				@close="isStatisticsVisible = false"
				v-if="isStatisticsVisible"
				:hide-footer="true">
				<template slot="header">
					{{ $t('Statistics') }} {{selected.name}}
				</template>
				<template slot="body">
				<div class="pb-3 mh-420 pt-3">
					<my-user-statistics :userId="userId" @close="closeGetStatistics"></my-user-statistics>
				</div>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loading from 'vue-loading-overlay';
import VueXlsx from '@/components/ImportExcel.vue';
import UserStatistics from '@/components/UserStatistics.vue';
import MyUserStatistics from '@/views/MyStatistics.vue';
import Modal from '@/components/Modal.vue';
import UserForm from '@/components/UserForm.vue';
import UserFormSettings from '@/components/UserFormSettings.vue';
import UserFormForceChangePassword from '@/components/UserFormForceChangePassword.vue';
import ModalPackageFeaturesUsers from '@/components/ModalPackageFeaturesUsers.vue';
import Pagination from '@/components/Pagination.vue';
import {
	getAxiosErrorMessage, delay, convertTimezone, addZeroUTC, duplicateVar, downloadBlob, elpisisString,
} from '@/lib/helper';
import usersApi from '@/api/user';

export default {
	name: 'Users',
	components: {
		Modal,
		UserForm,
		UserFormSettings,
		UserFormForceChangePassword,
		ModalPackageFeaturesUsers,
		Pagination,
		UserStatistics,
		VueXlsx,
		Loading,
		MyUserStatistics,
	},
	data() {
		return {
			page: 1,
			limit: 10,
			orderBy: 'logged_in_at',
			sortBy: 'desc',
			keyword: '',
			role: 'client',
			isAll: false,
			items: [],
			tmpUsers: [],
			selected: null,
			// totalPages: 2,
			totalItems: 0,
			lastPage: 1,
			roles: [
				{ key: 'all', label: 'All Roles' },
				{ key: 'client', label: 'Client' },
				{ key: 'super_admin', label: 'Super Admin' },
				{ key: 'collaborator', label: 'Collaborator' },
			],
			filterRole: null,
			isFormVisible: false,
			isFormSettingVisible: false,
			isFormChangePasswordVisible: false,
			isConfirmRemoveVisible: false,
			isRemoving: false,
			isFetching: false,
			hover: false,
			hoverItem: null,
			isVerified: '',
			roleFilter: '',
			isImportUserVisible: false,
			isExportUserVisible: false,
			isImporting: false,
			isExporting: false,
			fullPage: true,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',
			itemCounting: '',
			isForceDelete: false,
			showDropDownMenu: false,
			isStatisticsVisible: false,
			isFormLimitSubsVisible: false,
			userId: '',
		};
	},
	mounted() {
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
	},
	methods: {
		onResizeWidth() {
			if (window.innerWidth <= 1640 && window.innerWidth > 0) {
				this.showDropDownMenu = true;
			} else {
				this.showDropDownMenu = false;
			}
		},
		itemLeave() {
			this.hover = false;
			this.hoverItem = null;
		},
		itemHover(item) {
			this.hover = true;
			this.hoverItem = item.id;
		},
		...mapActions({
		}),
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) this.page = page;
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) this.isAll = true;
				this.items = items;
				for (let index = 0; index < this.items.length; index++) {
					const roles = this.items[index].roles;
					const rolesData = JSON.parse(roles);
					this.items[index].roles = rolesData;
				}
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isFetching = false;
			};
			usersApi.getUsers(params, callback, errorCallback);
		},
		changeLimit(value) {
			this.limit = value;
			this.fetch(true);
		},
		onKeywordChange() {
			delay(() => {
				this.fetch(true);
			}, 500);
		},
		insertItem(item) {
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				const roles = item.roles;
				const rolesData = JSON.parse(roles);
				item.roles = rolesData; // eslint-disable-line no-param-reassign
				this.items.push(item);
			} else {
				const roles = item.roles;
				const rolesData = JSON.parse(roles);
				item.roles = rolesData; // eslint-disable-line no-param-reassign
				this.$set(this.items, index, item);
			}
		},
		changePassword(item) {
			this.selected = item;
			this.isFormChangePasswordVisible = true;
		},
		addItem() {
			this.selected = null;
			this.isFormVisible = true;
		},
		editItem(item) {
			this.selected = item;
			this.isFormVisible = true;
		},
		settingItem(item) {
			this.selected = item;
			this.isFormSettingVisible = true;
		},
		limitSubscription(item) {
			this.selected = item;
			this.isFormLimitSubsVisible = true;
		},
		verifiedItem(item) {
			const params = {
				is_verified: !item.is_verified,
			};
			const callback = (response) => {
				const user = response.data;
				const message = response.message;
				this.insertItem(user);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Update User',
					text: message,
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update User',
					text: message,
				});
			};
			usersApi.update(item.id, params, callback, errorCallback);
		},
		confirmRemoveItem(item) {
			this.selected = item;
			this.isConfirmRemoveVisible = true;
		},
		removeItem(item) {
			this.isRemoving = true;
			const callback = (response) => {
				const message = response.message;
				const index = this.items.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					this.items.splice(index, 1);
				}
				this.isRemoving = false;
				this.isConfirmRemoveVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Remove User',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isRemoving = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Remove User',
					text: message,
				});
			};
			const params = {
			};
			if (this.isForceDelete) params.is_force_delete = this.isForceDelete;
			usersApi.delete(item.id, params, callback, errorCallback);
		},
		onPageSelected(page) {
			this.fetch(true, page);
		},
		formatText(str) {
			if (typeof (str) === 'string') {
				const text = str.split('_');
				let i = 0;
				for (i; i < text.length; i++) {
					text[i] = text[i].charAt(0).toUpperCase() + text[i].slice(1);
				}
				return text.join(' ');
			}
			return '';
		},
		convertUTC(date) {
			const d = new Date(date);
			const h = addZeroUTC(d.getUTCHours());
			const m = addZeroUTC(d.getUTCMinutes());
			const s = addZeroUTC(d.getUTCSeconds());
			return `${h}:${m}:${s}`;
		},
		getRelativeTime(item) {
			let time = '-';
			if (item.created_at) {
				if (!item.timezone) {
					time = item.created_at;
					time = new Date(time);
					const result = `${time.getDate()}-${(time.getMonth() + 1)}-${time.getFullYear()}/${this.convertUTC(item.created_at)}`;
					time = result;
				} else {
					time = convertTimezone(item.created_at, item.timezone);
				}
			}
			return time;
		},
		getLastLogin(item) {
			let time = '-';
			if (item.logged_in_at) {
				if (!item.timezone) {
					time = item.logged_in_at;
					time = new Date(time);
					const result = `${time.getDate()}-${(time.getMonth() + 1)}-${time.getFullYear()}/${this.convertUTC(item.logged_in_at)}`;
					time = result;
				} else {
					time = convertTimezone(item.logged_in_at, item.timezone);
				}
			}
			return time;
		},
		handleImportBulk(excelDataConverted) {
			const excelData = duplicateVar(excelDataConverted.body);
			this.tmpUsers = excelData;
		},
		acceptImport() {
			this.createBulk(this.tmpUsers);
		},
		createBulk() {
			this.isImporting = true;
			const callback = (response) => {
				const data = response.data;
				const message = response.message;
				const newUsers = data.createdUsers;
				const existingEmail = data.emailUsed;
				const existingUsers = data.recoveryUsers;
				newUsers.forEach((item) => {
					this.insertItem(item);
				});
				existingUsers.forEach((item) => {
					this.insertItem(item);
				});
				existingEmail.forEach((item) => {
					this.insertItem(item);
				});
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Import User',
					text: message,
				});
				this.isImportUserVisible = false;
				this.isImporting = false;
				this.tmpUsers = [];
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Import User',
					text: message,
				});
				this.isImportUserVisible = false;
				this.isImporting = false;
			};
			usersApi.createBulk((this.tmpUsers), callback, errorCallback);
		},
		exportUsers(type) {
			this.isExporting = true;
			const params = {
				page: 1,
				limit: 3000,
			};
			const callback = (response) => {
				const contents = response;
				downloadBlob(contents, { name: `${this.$t('Users')}`, type });
				this.isExporting = false;
			};
			const errorCallback = () => {
				this.isExporting = false;
			};
			usersApi.exportList(type, params, callback, errorCallback);
		},
		numberingList(index) {
			if (this.page >= 1) {
				return index + 1 + (this.page * 10 - 10);
			}
			return index + 1;
		},
		showModalName(str) {
			return elpisisString(str);
		},
		collaboratorList(item) {
			const collabResult = [];
			const empty = '';
			const collab = item && item.collaborators ? item.collaborators : '';
			if (collab.length > 0) {
				for (let index = 0; index < collab.length; index++) {
					const element = collab[index].inviter_name;
					collabResult.push(` ${element}`);
				}
				return `Invited by ${collabResult}`;
			}
			return empty;
		},
		lastLoginAt(filter) {
			if (filter === 'all') {
				this.orderBy = 'id';
			} else if (filter === 'last') {
				this.orderBy = 'logged_in_at';
			} else {
				this.orderBy = 'subscription';
			}
		},
		sortFilter(filter) {
			if (filter === 'asc') {
				this.sortBy = 'asc';
			} else {
				this.sortBy = 'desc';
			}
		},
		getStatistics(item) {
			this.isStatisticsVisible = true;
			this.selected = item;
			this.userId = item.id;
		},
		closeGetStatistics() {
			this.selected = null;
			this.isStatisticsVisible = false;
			this.userId = '';
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		fetchParams() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
				is_verified: this.isVerified,
				role: this.roleFilter,
			};
			const keyword = this.keyword.trim();
			if (keyword !== '') params.keyword = keyword;
			return params;
		},
		totalPages() {
			const total = Math.ceil(this.totalItems / this.limit);
			return total;
		},
	},
	watch: {
		isVerified() {
			this.fetch(true);
		},
		roleFilter() {
			this.fetch(true);
		},
		sortBy() {
			this.fetch(true);
		},
		orderBy() {
			this.fetch(true);
		},
	},
	created() {
		this.fetch();
	},
};
</script>
